import {
	GET_RETIRE_APPLICATION_SUCCESS,
	PATCH_INVESTOR_APPLICATION_SUCCESS,
	POST_USER_SUCCESS,
} from 'stash/actions/api';
import { SET_INVESTOR_APPLICATION_EMPLOYMENT_STATUS } from 'stash/actions/investorApplication';
import { GRAPHQL_GET_INVESTOR_APPLICATION_SUCCESS } from 'stash/actions/apolloGraphql';

const investor_application = (state = {}, action) => {
	switch (action.type) {
		case POST_USER_SUCCESS:
		case GRAPHQL_GET_INVESTOR_APPLICATION_SUCCESS:
			return {
				...state,
				...action.response.investor_application,
			};

		case PATCH_INVESTOR_APPLICATION_SUCCESS:
			return {
				...state,
				...action.response.investor_application,
			};

		case GET_RETIRE_APPLICATION_SUCCESS:
			return {
				...state,
				retire_questions: action.response.retire_questions,
				retire_constants: action.response.retire_constants,
			};

		case SET_INVESTOR_APPLICATION_EMPLOYMENT_STATUS:
			const { payload } = action;
			return {
				...state,
				...payload,
			};
		default:
			return state;
	}
};

export default investor_application;
